import React from "react";
import PropTypes from "prop-types";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
//Limitless imports
import { withi18n } from "@limitless/customer/components";

const NewQuestionTextInput = ({ t, classes, label, error, helperText, containerClass, ...rest }) => {
    const { labelText, textInput, placeholder, ...otherClasses } = classes;

    return (
        <div className={containerClass}>
            <Typography variant="body2" component="div" className={labelText}>
                {t(label)}
            </Typography>
            <TextField
                variant="outlined"
                label=""
                inputProps={{ className: textInput }}
                InputProps={{ classes: { ...otherClasses } }}
                style={{ marginTop: 1 }}
                {...rest}
            />
            {error ? <FormHelperText error={error}>{t(helperText)}</FormHelperText> : <div className={placeholder} />}
        </div>
    );
};

const styles = theme => ({
    labelText: {
        marginBottom: 4
    },
    textInput: {
        fontSize: "0.875rem",
        "@media screen and (max-width: 450px)": {
            fontSize: 16
        }
    },
    placeholder: {
        height: 20
    },
    root: {
        "& $notchedOutline": {
            border: "1px solid rgba(0,0,0,0.23)"
        },
        "&:hover $notchedOutline": {
            borderColor: "rgba(0,0,0,0.23)"
        },
        "&$focused $notchedOutline": {
            borderColor: theme.palette.primary.main,
            borderWidth: 2
        }
    },
    //Empty objects are needed to reset the MUI styles
    notchedOutline: {},
    focused: {}
});

export default withStyles(styles)(withi18n(NewQuestionTextInput));

NewQuestionTextInput.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    helperText: PropTypes.string,
    containerClass: PropTypes.string
};
